import React, { Component } from "react";
import { connect } from "react-redux";
class IRSourceEntranceAnalysis  extends Component {
    componentDidMount() {
        // 設置一秒後轉址到外部網址
        this.timer = setTimeout(() => {
          window.open('https://tabir.tut.edu.tw/views/7/3?:iid=3?:embed=yes&:toolbar=yes#1', '_blank'); // 在新分頁中打開外部網址
        }, 1000);
      }
  
    componentWillUnmount() {
      // 清除計時器以避免內存洩漏
      clearTimeout(this.timer);
    }
  
    render() {
      return (
        <div>
          <h1>IR【日四技】各入學管道生源分析</h1>
          <p>本分析介面及數據整理由校發中心提供</p>
        </div>
      );
    }
  }
export default connect((state) => ({ user: state.user }), {})(IRSourceEntranceAnalysis);